import { withNamespaces } from "react-i18next";
import { Text, View } from "@react-pdf/renderer";
import styles from "../../Styles";

const Appendices = ({ t, company, company_shareholders, management_team }) => {

const executivesAppendix = (() => {
    const list = (management_team ?? [])
        .map((p) => (p?.fullName ?? "").trim())
        .filter(Boolean);

    // de-dupe while preserving order
    const seen = new Set();
    return list.filter((name) => {
        const key = name.toLowerCase();
        if (seen.has(key)) return false;
        seen.add(key);
        return true;
    });
    })();

  const addressAppendix = (() => {
    const shareholders = company_shareholders ?? [];

    const blocks = [];

    

    // Establishment
    blocks.push({
      label: "Establishment Address",
      lines: [
        company?.establishmentAddress,
        [
          company?.establishmentAddressPostCode,
          company?.establishmentAddressCity,
        ]
          .filter(Boolean)
          .join(" "),
        company?.establishmentAddressRegion,
        company?.establishmentAddressCountry,
        company?.establishmentAddressCountryIso
          ? `Country ISO: ${company.establishmentAddressCountryIso}`
          : null,
      ].filter(Boolean),
    });

    // Correspondence (if present)
    if (company?.correspondenceAddress) {
      blocks.push({
        label: "Correspondence Address",
        lines: [company.correspondenceAddress].filter(Boolean),
      });
    }

    // Shareholders addresses (optional but matches “full address details” idea)
    shareholders.forEach((s, idx) => {
      const lines = [
        s?.address,
        [s?.postcode, s?.city].filter(Boolean).join(" "),
        s?.region,
        s?.country,
        s?.countryIso ? `Country ISO: ${s.countryIso}` : null,
        s?.companyType ? `Type: ${s.companyType}` : null,
      ].filter(Boolean);

      if (lines.length) {
        blocks.push({
          label: `Shareholder Address ${idx + 1}${
            s?.name ? ` (${s.name})` : ""
          }`,
          lines,
        });
      }
    });

    return blocks;
  })();

  return (
    <View style={styles.section} break>
      <Text style={styles.sectionSeparator}>
        {`${t("7.")} ${t("APPENDICES")}`}
      </Text>

      {/* A */}
      <Text style={styles.alphListItem}>
        {`7.1 ${t("All Executive Names List")}`}
      </Text>


      <View style={{ marginLeft: 18, marginTop: 6 }}>
        {executivesAppendix.length ? (
          executivesAppendix.map((name, i) => (
            <Text key={i} style={{ marginBottom: 2 }}>
              {`• ${name}`}
            </Text>
          ))
        ) : (
          <Text>{t("-")}</Text>
        )}
      </View>

      {/* B */}
      <View style={{ marginTop: 12 }}>
        <Text style={styles.alphListItem}>
            {`7.2 ${t("Full Address Details")}`}
        </Text>

        <View style={{ marginLeft: 18, marginTop: 6 }}>
          {addressAppendix.length ? (
            addressAppendix.map((b, i) => (
              <View key={i} style={{ marginBottom: 8 }}>
                <Text style={{ ...styles.fontBold, marginBottom: 2 }}>
                  {`• ${b.label}`}
                </Text>
                {b.lines.map((line, j) => (
                  <Text key={j} style={{ marginLeft: 10, marginBottom: 1 }}>
                    {line}
                  </Text>
                ))}
              </View>
            ))
          ) : (
            <Text>{t("-")}</Text>
          )}
        </View>
      </View>
    </View>
  );
};

export default withNamespaces()(Appendices);
